import { ExportStatus } from 'app/area/my-downloads/exports/exports-view/types-store';

export const ACTION = {
  REQUEST_EXPORT_STATUS: 'EXPORTS:REQUEST_CASES_LIST',
  RECEIVE_EXPORT_STATUS: 'EXPORTS:RECEIVE_CASES_LIST',
  FAIL_EXPORT_STATUS: 'EXPORTS:FAIL_EXPORT_STATUS',
  REQUEST_DOWNLOAD_CASE_EXPORT_PACKAGE: 'EXPORTS:REQUEST_DOWNLOAD_CASE_EXPORT_PACKAGE',
  RECEIVE_DOWNLOAD_CASE_EXPORT_PACKAGE: 'EXPORTS:RECEIVE_DOWNLOAD_CASE_EXPORT_PACKAGE',
  FAIL_DOWNLOAD_CASE_EXPORT_PACKAGE: 'EXPORTS:FAIL_DOWNLOAD_CASE_EXPORT_PACKAGE'
};

export class RequestExportStatus {
  public type: string = ACTION.REQUEST_EXPORT_STATUS;
}

export class ReceiveExportStatus {
  public type: string = ACTION.RECEIVE_EXPORT_STATUS;
  public exportStatus: ExportStatus[];

  constructor(exportStatus: ExportStatus[]) {
    this.exportStatus = exportStatus;
  }
}

export class FailExportStatus {
  public type: string = ACTION.FAIL_EXPORT_STATUS;
}

export class RequestDownloadCaseExportPackage {
  public type: string = ACTION.REQUEST_DOWNLOAD_CASE_EXPORT_PACKAGE;
  public exportId: string;

  constructor(exportId: string) {
    this.exportId = exportId;
  }
}

export class ReceiveDownloadCaseExportPackage {
  public type: string = ACTION.RECEIVE_DOWNLOAD_CASE_EXPORT_PACKAGE;
  public exportId: string;

  constructor(exportId: string) {
    this.exportId = exportId;
  }
}

export class FailDownloadCaseExportPackage {
  public type: string = ACTION.FAIL_DOWNLOAD_CASE_EXPORT_PACKAGE;
  public exportId: string;

  constructor(exportId: string) {
    this.exportId = exportId;
  }
}
